import { showFileDownloadToast } from "@hooks/crud/fileGeneration/fileDownloadToast";
import React, { useEffect, useState } from "react";

import {
  DownloadState,
  PdfDownloadContext,
  usePdfDownloadContext
} from "./pdfDownloadContext";

type PdfDownloadProviderProps = {
  children: React.ReactNode;
};

const PdfDownloadProvider: React.FC<PdfDownloadProviderProps> = ({
  children
}) => {
  const [downloads, setDownloads] = useState<DownloadState[]>([]);

  useEffect(() => {
    downloads.forEach((download) => {
      showFileDownloadToast(download.downloadStep, download.id);
    });
  }, [downloads]);

  return (
    <PdfDownloadContext.Provider value={{ downloads, setDownloads }}>
      {children}
    </PdfDownloadContext.Provider>
  );
};

export { PdfDownloadProvider, usePdfDownloadContext };
export type { DownloadState } from "./pdfDownloadContext";
